import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=787880ab&scoped=true"
import script from "./VideoDialog.vue?vue&type=script&lang=js"
export * from "./VideoDialog.vue?vue&type=script&lang=js"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=787880ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787880ab",
  null
  
)

export default component.exports